import React from 'react'

// Constants
import { SKETCH_WEBSITE } from 'constants/sketchWebsite'

// Components
import Modal from 'components/Modal'
import Button from 'components/Button'
import { ModalInjectedProps } from 'containers/ModalManager'

// Types
import { useShareReportMutation } from 'gqlTypes'

interface ReportShareModalProps extends ModalInjectedProps {
  shortId: string
}

const ReportShareModal: React.FC<ReportShareModalProps> = props => {
  const { hideModal, shortId } = props

  const [reportShare, { data, error, loading }] = useShareReportMutation({
    redirectErrors: true,
    variables: { id: shortId },
    onError: 'show-toast',
  })

  if (data && !error) {
    return (
      <Modal title="Report Submitted" onCancel={hideModal}>
        <Modal.Body>
          Thank you for submitting your report. We will review the document and
          its compliance with the{' '}
          <a
            href={`${SKETCH_WEBSITE}/tos`}
            target="_blank"
            rel="noopener noreferrer">
            Sketch Cloud Terms of Service
          </a>
          .
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  return (
    <Modal title="Report Document" onCancel={hideModal}>
      <Modal.Body>Are you sure you want to report this document?</Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal} disabled={loading}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => reportShare()}
          loading={loading}>
          Report
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ReportShareModal
